var TaikoDevice = {
  isIOS: /iPad|iPhone|iPod/.test(navigator.platform)
  || ((navigator.platform === 'MacIntel') && navigator.maxTouchPoints > 1),
  os: { name: null, majorVersion: null, minorVersion: null },
  motionSupported: null,

  init: function(){
    if(this.isIOS){
      let match = navigator.appVersion.match(/((iPhone|iPad) OS ([1-9][1-9])_?([1-9])?)|((iPad); CPU OS ([0-9][0-9])_?([0-9]))|((Version)\/([1-9][1-9]))/m)
      console.log(match)
      if(match != null && match !== undefined){
        let matchValues = []
        if(match[1] !== undefined){
          // first regex pattern
          matchValues = [match[2],match[3],match[4]]
        } else if(match[5] !== undefined){
          // second regex pattern
          matchValues = [match[6],match[7],match[8]]
        } else if(match[9] !== undefined){
          // third regex pattern 
          matchValues = ["iOS", match[11], "unknown"]
        }

        this.os.name = matchValues[0]
        this.os.majorVersion = matchValues[1]
        this.os.minorVersion = matchValues[2]
      } else {
        this.os.name = "other"
      }
    } else {
      this.os.name = "other"
    }
    
    if(window.DeviceMotionEvent !== undefined){
      this.motionSupported = true
    } else {
      if(this.isIOS){
        this.motionSupported = true
      } else {
        this.motionSupported = false
      }
    }
    return this
  }
}

export { TaikoDevice }